import './i18n/i18n';
import './style/global.css';
export { ClapprPlayer } from './components/player';
//# sourceMappingURL=index.js.map